var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconScanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-scanning"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-scanning",
    clipPath: "url(#clip-icon-scanning)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 265.344,
    height: 56,
    rx: 16,
    transform: "translate(724.977 189.052)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 265.344,
    height: 56,
    rx: 16,
    transform: "translate(724.977 567.026)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 265.344,
    height: 56,
    rx: 16,
    transform: "translate(724.977 693.444)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 265.344,
    height: 88,
    rx: 16,
    transform: "translate(724.977 803.862)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 265.344,
    height: 88,
    rx: 16,
    transform: "translate(724.977 424.609)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 265.344,
    height: 88,
    rx: 16,
    transform: "translate(724.977 298.191)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M627.495,215.774H258.321c-92.635,0-168,75.364-168,168v61.76c0,67.92,40.516,126.553,98.646,153.006L103,739.088a60,60,0,0,0,19.876,82.492l99.069,60.6A60.037,60.037,0,0,0,304.436,862.3l59.609-97.453H510.321a60.068,60.068,0,0,0,60-60V617.534c0-1.34-.047-2.674-.134-4h57.308a60.068,60.068,0,0,0,60-60V275.774A60.068,60.068,0,0,0,627.495,215.774ZM256.664,833.08a4.005,4.005,0,0,1-5.5,1.326l-99.07-60.6a4.005,4.005,0,0,1-1.325-5.5l94.959-155.245q6.237.463,12.592.47H390.954ZM514.321,617.534v87.314a4,4,0,0,1-4,4H398.3l42.365-69.262a59.952,59.952,0,0,0,8.567-26.052h63.208l-.246.458A4.007,4.007,0,0,1,514.321,617.534Zm117.174-64a4,4,0,0,1-4,4H258.321a112.127,112.127,0,0,1-112-112v-61.76a112.127,112.127,0,0,1,112-112H627.495a4,4,0,0,1,4,4Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScanning);
export default __webpack_public_path__ + "static/media/icon-scanning.337311a337fe57cae024098b51dad0f5.svg";
export { ForwardRef as ReactComponent };